import * as React from 'react';
import { styled } from '@glitz/react';
import { CheckCircleIcon } from 'webapp/components/icons';

type PropType = {
  highlights: NordicNest.Api.HighlightApiModel[];
};

export const Highlights = (props: PropType) => {
  return props?.highlights?.length > 0 ? (
    <Container>
      {props.highlights.map((item, index) => (
        <Item key={index}>
          <Headline>{item.headline}</Headline>
          {item.showAsCheckmark ? <CheckIcon /> : <Value>{item.value}</Value>}
        </Item>
      ))}
    </Container>
  ) : null;
};

const Container = styled.div({
  marginBottom: t => t.sharedSpacing.xl,
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  border: { xy: { style: 'solid', color: t => t.borderStrongColor, width: 1 } },
  padding: { y: t => t.sharedSpacing.m },
  gap: t => t.sharedSpacing.m,
});

const Item = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  rowGap: 6,
  fontSize: t => t.sharedFontSize.xs,
});

const Headline = styled.div({
  fontWeight: 400,
});

const Value = styled.div({
  fontWeight: 'bold',
});

const CheckIcon = styled(CheckCircleIcon, {
  width: 14,
  height: 14,
  marginTop: 2,
});
